import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2ea3523c&scoped=true&%3Akey=%24route.path"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3523c",
  null
  
)

export default component.exports